import { Action } from '@ngrx/store';
import { User } from '../../_models/user';

export enum UserActitonTypes {
	GetCurrentUser = '[User] Get Current',
	SetCurrentUser = '[User] Set Current',
	ClearUser = '[User] Clear',
	InicializeUser = '[User] Inicialize',
	LoadUsers = '[User] Load',
	LoadSuccessUsers = '[User] Load Success',
	LoadFailUsers = '[User] Load Fail'
}

export class GetCurrentUser implements Action {
	readonly type = UserActitonTypes.GetCurrentUser;
}

export class SetCurrentUser implements Action {
	readonly type = UserActitonTypes.SetCurrentUser;

	constructor(public payload: User) {}
}

export class ClearUser implements Action {
	readonly type = UserActitonTypes.ClearUser;
}

export class InicializeUser implements Action {
	readonly type = UserActitonTypes.InicializeUser;
}

export class LoadUsers implements Action {
	readonly type = UserActitonTypes.LoadUsers;

	constructor(public payload: User[]) {}
}

export class LoadSuccessUsers implements Action {
	readonly type = UserActitonTypes.LoadSuccessUsers;

	constructor(public payload: User[]) {}
}

export class LoadFailUsers implements Action {
	readonly type = UserActitonTypes.LoadFailUsers;

	constructor(public payload: string) {}
}

// Unión de acciones
export type UserActions = GetCurrentUser
| SetCurrentUser
| ClearUser
| InicializeUser
| LoadUsers
| LoadSuccessUsers
| LoadFailUsers;